module.exports = __webpack_public_path__ + "static/media/loader.f88f2976.gif";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/loader.gif
// module id = 8
// module chunks = 0